import Alert from 'react-bootstrap/Alert';
let message = "There was an error getting the data. Please contact the support.";

export function ApiErrorMessage(props) {
if(props.isApiError)
{
    return (
        <>
        <div className="apiErrormessageContainer"></div>
        <div className="apiErrorMessage">
            {/* <Alert variant="danger">{process.env.REACT_APP_ERROR_MESSAGE}</Alert> */}
            <Alert variant="danger">{message}</Alert>
        </div>
        </>
    );
}

}

// export default ApiErrorMessage;

export function ModalApiErrorMessage(props) {
    if(props.isApiError)
    {
        return (
            <>
            <div className="apiModalErrormessageContainer"></div>
            <div className="apiModalErrorMessage">
                <Alert variant="danger">{message}</Alert>
            </div>
            </>
        );
    }
    
    }
    
    // export default ModalApiErrorMessage;